var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, EventEmitter } from '@angular/core';
import { HasSubscriptions } from '../../has-subscriptions';
import { CommunicationService } from '../../../services/communication.service';
import { ListingCategory } from '../../../classes/enums';
import { StaticPathPipe } from '../../../shared/pipes/static-path.pipe';
import { Router } from '@angular/router';
var commercialImgHeight = 30;
var residentialImgHeight = 23;
var luxuryActiveImgHeight = 62;
var luxuryInactiveImgHeight = 30;
var commercialImgWidth = 140;
var residentialImgWidth = 140;
var luxuryActiveImgWidth = 200;
var luxuryInactiveImgWidth = 140;
var LeftNavComponent = /** @class */ (function (_super) {
    __extends(LeftNavComponent, _super);
    function LeftNavComponent(_communicationService, staticPathPipe, router) {
        var _this = _super.call(this) || this;
        _this._communicationService = _communicationService;
        _this.staticPathPipe = staticPathPipe;
        _this.router = router;
        _this.showLeftNav = false;
        _this.onListingsClick = new EventEmitter();
        _this.onCloseLeftNavClick = new EventEmitter();
        _this.platform = ListingCategory.RESIDENTIAL;
        _this.icons = {
            top: {
                className: '',
                img: { src: '', height: 0, width: 0 },
                link: ''
            },
            left: {
                className: '',
                img: { src: '', height: 0, width: 0 },
                link: ''
            },
            right: {
                className: '',
                img: { src: '', height: 0, width: 0 },
                link: ''
            }
        };
        _this.imgs = (_a = {},
            _a[ListingCategory.RESIDENTIAL] = { n: 'REMAX_masterLogo@1x.svg', w: 'REMAX_masterLogo_white@1x.svg' },
            _a[ListingCategory.LUXURY] = { n: 'REMAX_Collection.svg', w: 'REMAX_Collection_white.svg' },
            _a[ListingCategory.COMMERCIAL] = { n: 'REMAX_Commercial.svg', w: 'REMAX_Commercial_white.svg' },
            _a);
        // enums
        _this.ListingPropertyType = ListingCategory;
        _this.addSub(_this._communicationService.listings.currentShownListingType.subscribe(function (s) { return _this.platform = s; }));
        _this.addSub(_this._communicationService.listings.currentShownListingType.subscribe(function (listingType) { return _this.setState(listingType); }));
        return _this;
        var _a;
    }
    LeftNavComponent.prototype.ngOnInit = function () { };
    LeftNavComponent.prototype.changeListingType = function (newListingType, e) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        this._communicationService.setCurrentListingType(newListingType);
                        return [4 /*yield*/, this.router.navigate([newListingType === ListingCategory.RESIDENTIAL ? '/' : '/' + ListingCategory[newListingType].toLowerCase()])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    LeftNavComponent.prototype.setState = function (nextListingCategory) {
        if (nextListingCategory === ListingCategory.RESIDENTIAL) {
            this.icons.top.img = this.getLinkImg(ListingCategory.RESIDENTIAL, nextListingCategory);
            this.icons.right.img = this.getLinkImg(ListingCategory.COMMERCIAL, nextListingCategory);
            this.icons.right.link = this.getLinkUrl(ListingCategory.COMMERCIAL, nextListingCategory);
            this.icons.left.img = this.getLinkImg(ListingCategory.LUXURY, nextListingCategory);
            this.icons.left.link = this.getLinkUrl(ListingCategory.LUXURY, nextListingCategory);
        }
        else if (nextListingCategory === ListingCategory.LUXURY) {
            this.icons.top.img = this.getLinkImg(ListingCategory.LUXURY, nextListingCategory);
            this.icons.left.img = this.getLinkImg(ListingCategory.RESIDENTIAL, nextListingCategory);
            this.icons.left.link = this.getLinkUrl(ListingCategory.RESIDENTIAL, nextListingCategory);
            this.icons.right.img = this.getLinkImg(ListingCategory.COMMERCIAL, nextListingCategory);
            this.icons.right.link = this.getLinkUrl(ListingCategory.COMMERCIAL, nextListingCategory);
        }
        else {
            this.icons.top.img = this.getLinkImg(ListingCategory.COMMERCIAL, nextListingCategory);
            this.icons.right.img = this.getLinkImg(ListingCategory.RESIDENTIAL, nextListingCategory);
            this.icons.right.link = this.getLinkUrl(ListingCategory.RESIDENTIAL, nextListingCategory);
            this.icons.left.img = this.getLinkImg(ListingCategory.LUXURY, nextListingCategory);
            this.icons.left.link = this.getLinkUrl(ListingCategory.LUXURY, nextListingCategory);
        }
    };
    LeftNavComponent.prototype.getLinkImg = function (listingCategory, nextListingCategory) {
        return {
            src: this.getLinkImgSrc(listingCategory, nextListingCategory),
            height: this.getLinkImgHeight(listingCategory, nextListingCategory),
            width: this.getLinkImgWidth(listingCategory, nextListingCategory),
            alt: "side-nav.left-nav." + ListingCategory[listingCategory].toLowerCase(),
            type: listingCategory
        };
    };
    LeftNavComponent.prototype.getLinkUrl = function (listingCategory, nextListingCategory) {
        if (listingCategory == ListingCategory.COMMERCIAL) {
            return '/commercial';
        }
        else if (listingCategory == ListingCategory.LUXURY) {
            return '/luxury';
        }
        else {
            return '/';
        }
    };
    LeftNavComponent.prototype.getLinkImgSrc = function (listingCategory, nextListingCategory) {
        var isLuxury = nextListingCategory === ListingCategory.LUXURY;
        var img = isLuxury ? this.imgs[listingCategory]['w'] : this.imgs[listingCategory]['n'];
        return this.staticPathPipe.transform("/assets/REMAX_Logo/" + img);
    };
    LeftNavComponent.prototype.getLinkImgHeight = function (listingCategory, nextListingCategory) {
        var isActive = listingCategory === nextListingCategory;
        switch (nextListingCategory) {
            case ListingCategory.COMMERCIAL: {
                return commercialImgHeight;
            }
            case ListingCategory.LUXURY: {
                return isActive ? luxuryActiveImgHeight : luxuryInactiveImgHeight;
            }
            default: {
                return residentialImgHeight;
            }
        }
    };
    LeftNavComponent.prototype.getLinkImgWidth = function (listingCategory, nextListingCategory) {
        var isActive = listingCategory === nextListingCategory;
        switch (nextListingCategory) {
            case ListingCategory.COMMERCIAL: {
                return commercialImgWidth;
            }
            case ListingCategory.LUXURY: {
                return isActive ? luxuryActiveImgWidth : luxuryInactiveImgWidth;
            }
            default: {
                return residentialImgWidth;
            }
        }
    };
    return LeftNavComponent;
}(HasSubscriptions));
export { LeftNavComponent };
